"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _TextInput = _interopRequireDefault(require("./TextInput"));

var _styling = require("../../toolkit/styling");

var _FormSelect = _interopRequireDefault(require("./FormSelect"));

var _providers = require("../../toolkit/providers");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TextInputWithSelect = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextInputWithSelect, _Component);

  var _super = _createSuper(TextInputWithSelect);

  function TextInputWithSelect() {
    var _this;

    (0, _classCallCheck2["default"])(this, TextInputWithSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "hasFocus", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onBlur", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onFocus", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(TextInputWithSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          textInputProps = _this$props.textInputProps,
          selectProps = _this$props.selectProps,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement(_FormSelect["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.leftConnectedDiv)
      }, selectProps, {
        hideBorder: true
      })), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.rightConnectedDiv),
        height: "100%"
      }, textInputProps, {
        hideBorder: true,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming.theme,
          themeColor = _this$context$theming.primary,
          borderPrimary = _this$context$theming.borderPrimary;
      var borderColor = this.hasFocus ? themeColor : borderPrimary;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          overflow: "hidden",
          border: "solid 1px ".concat(borderColor),
          borderRadius: 4
        },
        leftConnectedDiv: {
          border: "none",
          overflow: "hidden",
          maxHeight: "100%",
          margin: 0,
          width: "30%"
        },
        rightConnectedDiv: {
          borderLeft: "solid 1px ".concat(borderColor),
          overflow: "visible",
          maxHeight: "100%",
          margin: 0,
          flex: 1
        }
      });
    }
  }]);
  return TextInputWithSelect;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  textInputProps: {
    required: true,
    type: "TextInputProps",
    description: "Properties for [`TextInput`](/lego/component/TextInput)"
  },
  selectProps: {
    required: true,
    type: "SimpleSelectProps",
    description: "Properties for [`FormSelect`](/lego/component/FormSelect)"
  }
}, _class3.demoProps = {
  selectProps: {
    onSelected: function onSelected() {},
    selectedValue: "USD",
    options: [{
      value: "USD",
      text: "US Dollar"
    }, {
      value: "CNY",
      text: "Chinese Yuan"
    }]
  },
  textInputProps: {
    placeholder: "100.00"
  }
}, _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "hasFocus", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onBlur", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (e) {
      var onBlur = _this2.props.textInputProps.onBlur;
      _this2.hasFocus = false;

      if (onBlur) {
        onBlur(e);
      }
    };
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onFocus", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (e) {
      var onFocus = _this3.props.textInputProps.onFocus;
      _this3.hasFocus = true;

      if (onFocus) {
        onFocus(e);
      }
    };
  }
})), _class2)) || _class;

var _default = TextInputWithSelect;
exports["default"] = _default;